import { adminRepositories } from "data/admin/repositories";

export const bookingsRepo = {
  list(params) {
    return adminRepositories.bookings.list(params);
  },

  getById(id) {
    return adminRepositories.bookings.getById(id);
  },

  listByBusinessId(businessId) {
    return adminRepositories.bookings.listByBusinessId(businessId);
  },

  create(input) {
    return adminRepositories.bookings.create(input);
  },

  update(id, patch) {
    return adminRepositories.bookings.update(id, patch);
  },

  updateStatus(id, status) {
    return adminRepositories.bookings.updateStatus(id, status);
  },
};
